import { getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getUnderwriterReviewLinkSaga() {
    try {
        yield put(reduceLoading({ code: 'getUnderwriterReviewLink', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(
            fetch,
            `/api/PolicyTransactionCustomAction/action-link/UnderwriterReviewLink/${entity}`,
            {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    Accept: 'text/plain',
                    Authorization: session.authenticationToken.token,
                },
            },
        );

        if (response.ok === true) {
            const url = yield call([response, 'text']); // Endpoint returns just a URL string
            if (url && url.trim() !== '') {
                window.open(url, '_blank');
            } else {
                console.error('Underwriter review link returned empty URL');
                window.location = '/error';
            }
        } else {
            console.error('Failed to get underwriter review link:', response.statusText, response.status);
            window.location = '/error';
        }
    } catch (error) {
        console.error('Error calling underwriter review link:', error);
        window.location = '/error';
    } finally {
        yield put(reduceLoading({ code: 'getUnderwriterReviewLink', value: false }));
    }
}
